"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _react = _interopRequireWildcard(require("react"));
var _reactVirtualized = require("react-virtualized");
var _recompose = require("recompose");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2["default"])(o), (0, _possibleConstructorReturn2["default"])(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, _getPrototypeOf2["default"])(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
/**
 * Higher Order Component for wrapping component in AutoSizer. Used to pass
 * `height` and `width` as props to the wrapped component. Useful for components
 * which render content that doesn't inherently take up space (like a Chart) and
 * needs to be passed dimensions.
 *
 * Note that component must be rendered inside of a container (i.e div) with
 * it's own dimensions (not `auto`), otherwise the height/width passed to the child
 * component will be zero.
 */

var withAutoSizer = function withAutoSizer(InnerComponent) {
  var _WrappedComponent;
  return _WrappedComponent = /*#__PURE__*/function (_Component) {
    (0, _inherits2["default"])(WrappedComponent, _Component);
    function WrappedComponent() {
      (0, _classCallCheck2["default"])(this, WrappedComponent);
      return _callSuper(this, WrappedComponent, arguments);
    }
    (0, _createClass2["default"])(WrappedComponent, [{
      key: "render",
      value: function render() {
        var _this = this;
        return /*#__PURE__*/_react["default"].createElement(_reactVirtualized.AutoSizer, null, function (_ref) {
          var height = _ref.height,
            width = _ref.width;
          return /*#__PURE__*/_react["default"].createElement(InnerComponent, (0, _extends2["default"])({
            height: height,
            width: width
          }, _this.props));
        });
      }
    }]);
    return WrappedComponent;
  }(_react.Component), (0, _defineProperty2["default"])(_WrappedComponent, "displayName", "withAutoSizer(".concat((0, _recompose.getDisplayName)(InnerComponent), ")")), _WrappedComponent;
};
var _default = exports["default"] = withAutoSizer;
//# sourceMappingURL=withAutoSizer.js.map